import React from 'react'
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Corporate from "./pages/Admin/Corporate";
import UploadeEmployee from "./pages/Admin/UploadeEmployee";
import Login from './component/Admin/Login';
import Hr from "./pages/Admin/Hr";
import Employee from "./pages/Admin/Employee";
import Doctor from "./pages/Admin/Doctor";
import Report from "./pages/Hr/Report";
import UploadEmployee from "./pages/Hr/UploadEmployee";
import HrEmployee from "./pages/Hr/HrEmployee";
import AdminRoute from './pages/Admin/AdminRoute';
import HrRoute from './pages/Hr/HrRoute';
import CorporateRoute from './pages/Corporate/CorporateRoute';
import CorporateHr from './pages/Corporate/CorporateHr';
import CreateEmployee from './pages/Corporate/CreateEmployee';
import CorporateEmployee from './pages/Corporate/CorporateEmployee';
import ChangePassword from './component/Admin/ChangePassword ';
import AboutUs from './component/Admin/AboutUs';
import HealthTips from './pages/Admin/HealthTips';
import Chat from './component/Admin/Chat';
import PrivacyPolicy from './component/Admin/PrivacyPolicy';
import LabTest from './pages/Admin/LabTest';
import DoctorRoute from './pages/Doctor/DoctorRoute';
import TimeSlote from './pages/Doctor/TimeSlote';
import FamilyMember from './pages/Hr/FamilyMember';
import CorporateReport from './pages/Corporate/CorporateReport';
import EmployeeList from './pages/Doctor/EmployeeList';
import Appointment from './pages/Doctor/Appointment';
import Consultation from './pages/Doctor/Consultation';
import EmpChangePassword from './component/Admin/EmpChangePassword';
import WellnessPartner from './pages/Admin/WellnessPartner';
import Panel from './pages/Admin/Panel';
import Mirajpage from './pages/Mirajpage';
import Export from './pages/Admin/Export';
import MasterHr from './pages/MasterAdmin/Admins';
import MasterRoute from './pages/MasterAdmin/MasterRoute';
import BranchList from './pages/MasterAdmin/BranchList';
import Createmember from './pages/MasterAdmin/CreateMember';
import MemberList from './pages/MasterAdmin/MemberList';
import AdminVfs from './pages/Admin/AdminVfs';
import VfsRoute from './pages/Vfs/VfsRoute';
import VfsBranchList from './pages/Vfs/VfsBranchList';
import VfsBranchMember from './pages/VfsBranch/VfsBranchMember';
import VfsBranchRoute from './pages/VfsBranch/VfsBranchRoute';
import VfsCreatemember from './pages/Vfs/VfsCreateMember';
import VfsMemberList from './pages/Vfs/VfsMemberList';
import AdminFamilyMember from './pages/Admin/FamilyMember';
import Registration from './component/Admin/Registration';
import ThankYouPage from './component/Admin/Thankyou';
import AdminVfsUk from './pages/Admin/AdminVfsUk';
import VfsUkMember from './pages/Vfs/VfsUkmemberList';
import CreditNote from './pages/Admin/CreditNote';
import VfsUkCreditNoteList from './pages/Vfs/VfsUkCreditNoteList';
import PaymentFailed from './pages/Admin/PaymentFailed';
import AdminBls from './pages/Admin/AdminBls';
import OnevascoCreateMember from './pages/Onevasco/OnevascoCreateMember';
import OnevascoRoute from './pages/Onevasco/OnevascoRoute';
import OnevascoBranchList from './pages/Onevasco/OnevascoBranchList';
import OnevascoMemberList from './pages/Onevasco/OnevascoMemberList';
import OnevascoRoleList from './pages/Onevasco/OnevascoRoleList';
import VfsuklpMemberList from './pages/VfsUkLp/VfsuklpMemberList';
import VfsuklpRefund from './pages/VfsUkLp/VfsuklpRefund';
import VfsuklpRoleList from './pages/VfsUkLp/VfsuklpRoleList';
import VfsuklpBranchList from './pages/VfsUkLp/VfsuklpBranchList';
import VfsuklpRoute from './pages/VfsUkLp/VfsuklpRoute';
import TeamMemberList from './pages/Team/TeamMemberList';
import TeamRefundList from './pages/Team/TeamRefundList';
import TeamRoute from './pages/Team/TeamRoute';

import { useSelector } from "react-redux";
import TeamMembers from './pages/Admin/TeamMembers';
import AdminTeamMembers from './pages/Admin/AdminTeamMembers';

function Router() {

  const roleName = useSelector((state) => state.Auth.roleName);
  function ProtectedRoutes() {
    if (!roleName) {
      return <Navigate to="/login" />;
    }

    switch (roleName) {
      case "onevasco":
        return <Navigate to="/onevasco/login" />;
      case "vfs_uk_lp":
        return <Navigate to="/vfs_uk_lp/login" />;
      case "team":
        return <Navigate to="/vfs_uk_lp/team/login" />;
      default:
        return <Navigate to="/login" />;
    }
  }
  return (
    <Routes>
    <Route path="/" element={<Navigate to="/login" />} />
    <Route path="/login" element={<Login />} />
    <Route path="/vfs_uk" element={<Registration/>} />
    <Route path='/thankyou' element={<ThankYouPage/>} />
    <Route path="/changepassword" element={<ChangePassword />} />
    <Route path="/employee/changepassword/:id" element={<EmpChangePassword />} />
    <Route path="/aboutus" element={<AboutUs />} />
    <Route path="/chat" element={<Chat />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/mirajform" element={<Mirajpage />} />

    {/* Master Admin Route */}

    <Route path='/master/hr' element={<MasterRoute><MasterHr/></MasterRoute>} />
    <Route path='/master/branch' element={<MasterRoute><BranchList/></MasterRoute>} />
    <Route path='/master/create-member' element={<MasterRoute><Createmember/></MasterRoute>} />
    <Route path='/master/memberlist' element={<MasterRoute><MemberList/></MasterRoute>} />

    {/* Vfs Route */}

    <Route path='/vfs/branch' element={<VfsRoute><VfsBranchList/></VfsRoute>} />
    <Route path='/vfs/create-member' element={<VfsRoute><VfsCreatemember/></VfsRoute>} />
    <Route path='/vfs/memberlist' element={<VfsRoute><VfsMemberList/></VfsRoute>} />
    <Route path='/vfs_uk/memberlist' element={<VfsRoute><VfsUkMember/></VfsRoute>} />
    <Route path='/vfs_uk/creditnote' element={<VfsRoute><VfsUkCreditNoteList/></VfsRoute>} />

    {/* vfs branch route */}

    <Route path='/vfs-branch/member' element={<VfsBranchRoute><VfsBranchMember/></VfsBranchRoute>} />

    
    {/* Admin Route */}
    <Route path="/admin/admin_user/corporate" element={<AdminRoute> <Corporate/></AdminRoute>} />
    <Route path="/admin/admin_user/hr" element={<AdminRoute><Hr/></AdminRoute>} />
    <Route path="/admin/admin_user/uploadeemployee" element={<AdminRoute><UploadeEmployee/></AdminRoute>} />
    <Route path="/admin/admin_user/employee" element={<AdminRoute><Employee/></AdminRoute>} />
    <Route path="/admin/admin_user/doctor" element={<AdminRoute><Doctor/></AdminRoute>} />
    <Route path="/admin/admin_user/healthtips" element={<AdminRoute><HealthTips/></AdminRoute>} />
    <Route path="/admin/admin_user/labtest" element={<AdminRoute><LabTest/></AdminRoute>} />
    <Route path="/admin/admin_user/wellness-partner" element={<AdminRoute><WellnessPartner/></AdminRoute>} />
    <Route path="/admin/admin_user/panel" element={<AdminRoute><Panel/></AdminRoute>} />
    <Route path="/admin/export" element={<AdminRoute><Export/></AdminRoute>} />
    <Route path="/admin/admin_user/master" element={<AdminRoute><AdminVfs/></AdminRoute>} />
    <Route path="/admin/admin_user/family_member" element={<AdminRoute><AdminFamilyMember/></AdminRoute>} />
    <Route path="/admin/admin_user/vfs_uk" element={<AdminRoute><AdminVfsUk/></AdminRoute>} />
    <Route path="/admin/admin_user/credit_note" element={<AdminRoute><CreditNote/></AdminRoute>} />
    <Route path="/admin/admin_user/payment_failed" element={<AdminRoute><PaymentFailed/></AdminRoute>} />
    <Route path="/admin/admin_user/bls" element={<AdminRoute><AdminBls/></AdminRoute>} />
    <Route path="/admin/admin_user/vfs_team_members" element={<AdminRoute><TeamMembers/></AdminRoute>} />
    <Route path="/admin/admin_user/team_members" element={<AdminRoute><AdminTeamMembers/></AdminRoute>} />

    {/* Admin Role Routes */}
    <Route path="/admin/admin_team/login" element={<Login/>} />

    {/* hr Route */}
    <Route path="/hr/uploademployee" element={<HrRoute><UploadEmployee/></HrRoute>} />
    <Route path="/hr/employee" element={<HrRoute><HrEmployee/></HrRoute>} />
    <Route path="/hr/family-member" element={<HrRoute><FamilyMember/></HrRoute>} />
    <Route path="/hr/report" element={<HrRoute><Report/></HrRoute>} />

    {/* Corporate Route */}
    <Route path="/corporate/hr" element={<CorporateRoute><CorporateHr/></CorporateRoute>} />
    <Route path="/corporate/uploademployee" element={<CorporateRoute><CreateEmployee/></CorporateRoute>} />
    <Route path="/corporate/employee" element={<CorporateRoute><CorporateEmployee/></CorporateRoute>} />
    <Route path="/corporate/report" element={<CorporateRoute><CorporateReport/></CorporateRoute>} />

    {/* Doctor Route  */}
    <Route path='/doctor/time-slote' element={<DoctorRoute><TimeSlote/></DoctorRoute>} />
    <Route path='/doctor/employee-list' element={<DoctorRoute><EmployeeList/></DoctorRoute>} />
    <Route path='/doctor/appointment' element={<DoctorRoute><Appointment/></DoctorRoute>} />
    <Route path='/doctor/video-call' element={<DoctorRoute><Consultation/></DoctorRoute>} />
    


    {/* Onevasco Routes */}
    <Route path='/onevasco/login' element={<Login/>} />
    <Route path='/onevasco/branch' element={<OnevascoRoute><OnevascoBranchList/></OnevascoRoute>} />
    <Route path='/onevasco/create_member' element={<OnevascoRoute><OnevascoCreateMember/></OnevascoRoute>} />
    <Route path='/onevasco/memberlist' element={<OnevascoRoute><OnevascoMemberList/></OnevascoRoute>} />
    <Route path='/onevasco/role' element={<OnevascoRoute><OnevascoRoleList/></OnevascoRoute>} />

    {/* vfs uk lp Routes*/}
    <Route path='/vfs_uk_lp/login' element={<Login/>} />
    <Route path='/vfs_uk_lp/branch' element={<VfsuklpRoute><VfsuklpBranchList/></VfsuklpRoute>} />
    <Route path='/vfs_uk_lp/memberlist' element={<VfsuklpRoute><VfsuklpMemberList/></VfsuklpRoute>} />
    <Route path='/vfs_uk_lp/refunds' element={<VfsuklpRoute><VfsuklpRefund/></VfsuklpRoute>} />
    <Route path='/vfs_uk_lp/role' element={<VfsuklpRoute><VfsuklpRoleList/></VfsuklpRoute>} />

    {/* team routes */}
    <Route path='/vfs_uk_lp/team/login' element={<Login/>} />
    <Route path={`/vfs_uk_lp/${roleName}/memberlist`} element={<TeamRoute><TeamMemberList/></TeamRoute>} />
    <Route path={`/vfs_uk_lp/${roleName}/refund`} element={<TeamRoute><TeamRefundList/></TeamRoute>} />
    

    {/* Routing Protected  */}
    <Route path="*" element={<ProtectedRoutes />} />
    <Route path="/onevasco/*" element={<Navigate to="/onevasco/login" />} />
    <Route path="/vfs_uk_lp/*" element={<Navigate to="/vfs_uk_lp/login" />} />
    <Route path={`/vfs_uk_lp/${roleName}/*`} element={<Navigate to="/vfs_uk_lp/team/login" />} />

  </Routes>
  )
}

export default Router



